import { runtimeEnv } from 'config/runtimeEnv';
// src/services/TaxService.js
import requestInstance from './Request';

// Base URL for the Tax Master API (v3)
const BASE_URL = `${runtimeEnv('B2B_API_BASE_URL')}/admin-api/v3/tax-masters`;

const taxService = {
  // GET /admin-api/v3/tax-masters
  // Response: { success, data: [...], message }
  async getTaxList(params = {}) {
    try {
      const response = await requestInstance.get(BASE_URL, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching tax list:', error);
      throw error;
    }
  },

  // POST /admin-api/v3/tax-masters
  // Body: { name, percentage }
  // Response: { success, data: {...}, message }
  async createTax(taxData) {
    try {
      const response = await requestInstance.post(BASE_URL, taxData);
      return response.data;
    } catch (error) {
      console.error('Error creating tax master:', error);
      throw error;
    }
  },

  // GET /admin-api/v3/tax-masters/:id
  // Response: { success, data: {...}, message }
  async getTaxById(taxId) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/${taxId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tax master:', error);
      throw error;
    }
  },

  // PUT /admin-api/v3/tax-masters/:id
  // Body: { name, percentage }
  // Response: { success, data: {...}, message }
  async updateTax(taxId, updatedData) {
    try {
      const response = await requestInstance.put(`${BASE_URL}/${taxId}`, updatedData);
      return response.data;
    } catch (error) {
      console.error('Error updating tax master:', error);
      throw error;
    }
  },

  // PATCH /admin-api/v3/tax-masters/:id/disable
  // Response: { success, data: {...}, message }
  async disableTax(taxId) {
    try {
      const response = await requestInstance.patch(`${BASE_URL}/${taxId}/disable`);
      return response.data;
    } catch (error) {
      console.error('Error disabling tax master:', error);
      throw error;
    }
  },
};

export default taxService;
